import { StringKeyDictionary } from "../../commonInterfaces.js";
import { Saveable } from "../components/commonApp.js";
import { Config } from "../config/config.js";
import { DialogHelper } from "./dialogHelper.js";
import { InnosoftMobileApp } from "./innosoftMobileApp.js";

const getDiscardMessagePromise = () => {
    return new Promise<boolean>(async (resolve, reject) => {
        resolve(await DialogHelper.confirm(`${Config.translations.dataNotSavedMessage} ${Config.translations.closeAndDiscardMessage}`));
    });
}

const handleBeforeUnload = () => {
    if (handlers.some(x => x.isEnabled() && (!x.isEntitySaved() || x.hasUnsavedModules()))) {
        if (Config.settings.isMobileApp) {
            // Nachfrage, wenn die Electron-App über den Window-Controls geschlossen wird:
            getDiscardMessagePromise().then(discard => {
                if (discard) {
                    handlers.forEach(h => h.runAllCallbacks());
                    handlers.forEach(handler => handler.disable());
                    InnosoftMobileApp.close();
                }
            });
        }
        return Config.translations.dataNotSavedMessage;
    }

    handlers.forEach(h => h.runAllCallbacks());
}

const handlers: Array<UnloadHelper> = [];

const callbacks: StringKeyDictionary<Array<Function>> = {};


export const createSheetHandler = (loadedModules: Saveable[]) => {
    const id = kendo.guid();
    let isSaved = true, enabled = true;
    const modules = loadedModules;

    const handler: UnloadHelper = {
        disable: () => {
            enabled = false;
        },
        enable: () => {
            enabled = true;
        },
        isEnabled: () => {
            return enabled;
        },
        isEntitySaved: () => {
            return isSaved;
        },
        markEntityChanged: () => {
            isSaved = false;
        },
        markEntitySaved: () => {
            isSaved = true;
        },
        showUnloadMessage: () => {
            return getDiscardMessagePromise();
        },
        addBeforeUnloadCallback: (callback: Function) => {
            if (!Array.isArray(callbacks[id])) {
                callbacks[id] = [];
            }

            callbacks[id].push(callback);
        },
        removeBeforeUnloadCallback: (callback: Function) => {
            if (Array.isArray(callbacks[id])) {
                const idx = callbacks[id].indexOf(callback);
                if (idx !== -1) {
                    callbacks[id].splice(idx, 1);
                }
            }
        },
        removeAllCallbacks: () => {
            delete callbacks[id];
        },
        runAllCallbacks: () => {
            if (Array.isArray(callbacks[id])) {
                callbacks[id].forEach(f => f());
            }
        },
        hasUnsavedModules: () => {
            if (modules) {
                for (var m of modules) {
                    if (m.HasChanges()) {
                        return true;
                    }
                }
            }
            return false;
        }
    }

    handlers.push(handler);

    return handler;
}

export const removeHanlder = (handler: UnloadHelper) => {
    const idx = handlers.indexOf(handler);
    if (idx >= 0) {
        handler.removeAllCallbacks();
        handlers.splice(idx, 1);
    }
}

export const askToDiscardChanges = () => {
    return getDiscardMessagePromise();
}

export const initGlobalHandler = () => {
    $(window).on("beforeunload", handleBeforeUnload);
    window.addEventListener("pagehide", handleBeforeUnload);//Für Safari
}

export interface UnloadHelper {
    markEntitySaved: () => void;
    markEntityChanged: () => void;
    disable: () => void;
    enable: () => void;
    isEntitySaved: () => boolean;
    isEnabled: () => boolean;
    showUnloadMessage: () => Promise<boolean>;
    addBeforeUnloadCallback: (f: Function) => void;
    removeBeforeUnloadCallback: (f: Function) => void;
    removeAllCallbacks: () => void;
    runAllCallbacks: () => void;
    hasUnsavedModules: () => boolean;
}

